import { SurveysRoutes } from './type'

const surveys = `${SurveysRoutes.root}`

export const SurveysPath = {
  root: surveys,
  create: `${surveys}/${SurveysRoutes.create}`,
  view: `${surveys}/${SurveysRoutes.view}`,
}
